const UserActionTypes = {
	SET_CURRENT_USER: "SET_CURRENT_USER",
	VERIFY_2FA: "VERIFY_2FA",
	RESET_CONFIRMED_2FA: "RESET_CONFIRMED_2FA",
	SET_COMPANY_UPLOAD_LIMIT: "SET_COMPANY_UPLOAD_LIMIT",
};

export default UserActionTypes;
